export default "__VITE_ASSET__B_K5Gm4K__"